import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./carrossel.css";

export default function Carrossel({
  items = [],
  maxVisible = 4,
  tipo = "post" // "post" | "midia"
}) {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!items || items.length === 0) return null;

  const total = items.length;

  const handleNext = () =>
    setCurrentIndex((prev) => (prev + 1) % total);

  const handlePrev = () =>
    setCurrentIndex((prev) => (prev - 1 + total) % total);

  // 🔥 Paleta que se repete
  const cores = ["#A7D2CB", "#F2D388", "#C98474"];

  const visiveis = [];
  for (let i = 0; i < Math.min(maxVisible, total); i++) {
    visiveis.push(items[(currentIndex + i) % total]);
  }

  function handleClick(item) {
    if (tipo === "post") {
      navigate(`/posts/${item.id_post}`);
    }
  }

  return (
    <div className="carousel-container">
      <button className="arrow" onClick={handlePrev}>◀</button>

      <div className="carousel-wrapper">
        <div className="carousel-content">
          {visiveis.map((item, index) => (
            <div
              key={item.id_midia || item.id_post || index}
              className="post-card"
              onClick={() => handleClick(item)}
            >
              <img
                src={item.imagem_url}
                alt={item.titulo || "Imagem"}
              />

              {item.titulo && (
                <div
                  className="fundo-titulo"
                  style={{
                    backgroundColor: `${cores[(currentIndex + index) % cores.length]}cc`
                  }}
                >
                  <h2 className="post-title">{item.titulo}</h2>
                </div>
              )}

            </div>
          ))}
        </div>
      </div>

      <button className="arrow" onClick={handleNext}>▶</button>
    </div>
  );
}
